"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.StatusIndicator = exports.STATUS_SEMANTIC = void 0;
var React = _interopRequireWildcard(require("react"));
var COLORS = _interopRequireWildcard(require("../../styles/variables/_color"));
var _classify = _interopRequireDefault(require("../../utils/classify"));
var _StatusIndicatorModule = _interopRequireDefault(require("./StatusIndicator.module.css"));
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function (nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }
function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || typeof obj !== "object" && typeof obj !== "function") { return { default: obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj.default = obj; if (cache) { cache.set(obj, newObj); } return newObj; }
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
const STATUS_SEMANTIC = Object.freeze({
  primary: 'primary',
  information: 'information',
  success: 'success',
  warning: 'warning',
  danger: 'danger',
  neutral: 'neutral',
  secondary: 'secondary'
});
exports.STATUS_SEMANTIC = STATUS_SEMANTIC;
const StatusIndicator = /*#__PURE__*/React.forwardRef((_ref, ref) => {
  let {
    classNames,
    status = 'information',
    withBorder,
    borderColorToken = 'colorBackgroundTertiary',
    disabled,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("div", _extends({}, props, {
    "data-testid": "StatusIndicator",
    className: (0, _classify.default)(_StatusIndicatorModule.default.statusWrapper, _StatusIndicatorModule.default[status], {
      [_StatusIndicatorModule.default.withBorder]: withBorder,
      [_StatusIndicatorModule.default.disabled]: disabled
    }, classNames?.wrapper),
    ref: ref,
    style: {
      '--border-color': COLORS[borderColorToken] || COLORS['colorBackgroundTertiary']
    }
  }));
});
exports.StatusIndicator = StatusIndicator;